// React 19: render metadata tags directly; React will hoist/dedupe into <head>
const CustomHelmet = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogUrl,
  canonicalUrl,
  ogImage,
  twitterCard = "summary_large_image",
  jsonLd,
  noindex,
}) => (
  <>
    {title && <title>{title}</title>}
    {noindex && <meta name="robots" content="noindex, nofollow" />}
    {description && <meta name="description" content={description} />}
    {keywords && <meta name="keywords" content={keywords} />}

    {ogTitle && <meta property="og:title" content={ogTitle} />}
    {ogDescription && (
      <meta property="og:description" content={ogDescription} />
    )}
    {ogUrl && <meta property="og:url" content={ogUrl} />}
    {ogImage && <meta property="og:image" content={ogImage} />}

    {twitterCard && <meta name="twitter:card" content={twitterCard} />}
    {ogTitle && <meta name="twitter:title" content={ogTitle} />}
    {ogDescription && (
      <meta name="twitter:description" content={ogDescription} />
    )}
    {ogImage && <meta name="twitter:image" content={ogImage} />}

    {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

    {jsonLd && (
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    )}
  </>
);

export default CustomHelmet;
